import { Modal as MolyModal } from '@bfe/moly';
import { ModalProps } from '@bfe/moly/dist/es/components/ui/modal';
import { NoSSR } from '../noSSR';
import cls from 'classnames';

import styles from './index.module.scss';

export const Modal = (props: ModalProps) => {
  return (
    <NoSSR>
      <MolyModal {...props} className={cls(styles.modalBg, props?.className)}>
        {props.children}
      </MolyModal>
    </NoSSR>
  );
};
